import React from 'react';
import classnames from 'classnames';
import Plus from 'images/icon/counting-plus.inline.svg';
import Minus from 'images/icon/counting-minus.inline.svg';
import styles from './index.module.css';

interface CountingButtonProperty {
	className?: string;
	disabled?: boolean;
	plus: () => void;
	minus: () => void;
	count: number;
	max?: number;
	handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	minusDisabled?: boolean;
}

const CountingButton: React.FC<CountingButtonProperty> = ({
	className,
	disabled,
	plus,
	minus,
	count,
	max,
	handleChange,
	minusDisabled,
}) => (
	<div className={classnames(styles.countingButton, className, disabled && styles.disabled)}>
		<button
			onClick={minus}
			type="button"
			className={count === 0 || disabled || minusDisabled ? styles.btnDisabled : ''}
			disabled={count === 0 || disabled || minusDisabled}
		>
			<Minus />
		</button>

		<div>
			<input value={count} onChange={handleChange} disabled={disabled} />
		</div>

		<button
			onClick={plus}
			type="button"
			className={classnames(
				(count >= (max || Number.MAX_SAFE_INTEGER) || disabled) && styles.btnDisabled,
			)}
			disabled={count === max || disabled}
		>
			<Plus />
		</button>
	</div>
);

export default CountingButton;
